module.exports = __webpack_public_path__ + "static/media/go.8afd996f.svg";